import { BaseModel } from "@/models/BaseModel";
import { Activity } from "@/models/Activity";
import { Info } from "@/models/Info";
import { Person } from "@/models/Person";
import moment from "moment";


export class Checkstatus extends BaseModel {
  constructor({
    id = null,
    name,
    frequency,
    status,
    lastdate,
    deadline_date,
    questionnaire_id,
    activity = null,
    responsible = null,
    info = null,
    content = null
  }) {
    super();
    this.id = id;
    this.name = name;
    this.content = content;
    this.frequency = frequency;
    this.status = status;
    this.lastdate = lastdate;
    this.deadline_date = deadline_date;
    this.questionnaire_id = questionnaire_id;
    this.activity = activity ? new Activity(activity) : null;
    this.responsible = responsible ? new Person(responsible) : null;
    this.info = info ? new Info(info) : null;
  }

  get isOverdue() {
    let today = moment();
    return moment(this.deadline_date).isBefore(today, "day");
  }

}

export default Checkstatus;
